import React from 'react';
import { useTranslation } from '../i18n';

// A compact two-button pill that switches between English and Spanish.
// Variants:
//   - default (light pill on white)  → `variant="light"`
//   - dark/translucent (for green backgrounds) → `variant="dark"`
export default function LangToggle({ variant = 'light', style }) {
  const { t, lang, setLang } = useTranslation();
  const isDark = variant === 'dark';

  const wrap = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 2,
    padding: 3,
    borderRadius: 100,
    background: isDark ? 'rgba(255,255,255,0.14)' : '#f3f4ef',
    border: isDark ? '1px solid rgba(255,255,255,0.18)' : '1px solid #e3e9df',
    ...style,
  };
  const btn = {
    padding: '5px 10px',
    borderRadius: 100,
    border: 'none',
    background: 'transparent',
    fontSize: 11,
    fontWeight: 800,
    color: isDark ? 'rgba(255,255,255,0.75)' : '#5f6b58',
    cursor: 'pointer',
    fontFamily: 'inherit',
    letterSpacing: '0.04em',
  };
  const btnActive = isDark
    ? { background: '#fff', color: '#14653a' }
    : { background: '#fff', color: '#14653a', boxShadow: '0 1px 3px rgba(0,0,0,0.06)' };

  return (
    <div style={wrap} role="group" aria-label={t('a11y.language')}>
      <button
        type="button"
        style={{ ...btn, ...(lang === 'en' ? btnActive : {}) }}
        onClick={() => setLang('en')}
        aria-pressed={lang === 'en'}
      >
        EN
      </button>
      <button
        type="button"
        style={{ ...btn, ...(lang === 'es' ? btnActive : {}) }}
        onClick={() => setLang('es')}
        aria-pressed={lang === 'es'}
      >
        ES
      </button>
    </div>
  );
}
